import _Object$setPrototypeOf from "babel-runtime/core-js/object/set-prototype-of";
import _Object$create from "babel-runtime/core-js/object/create";
import _Object$getPrototypeOf from "babel-runtime/core-js/object/get-prototype-of";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = _Object$create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (_Object$setPrototypeOf) {
    _Object$setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var SplitNetworkError = function (_extendableBuiltin2) {
  _inherits(SplitNetworkError, _extendableBuiltin2);

  function SplitNetworkError(msg, code) {
    _classCallCheck(this, SplitNetworkError);

    var _this = _possibleConstructorReturn(this, (SplitNetworkError.__proto__ || _Object$getPrototypeOf(SplitNetworkError)).call(this, msg));

    _this.statusCode = code;
    return _this;
  }

  return SplitNetworkError;
}(_extendableBuiltin(Error));

export default SplitNetworkError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/services/transport/SplitNetworkError.js
// module id = LamT
// module chunks = 88